import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../../Shared/UserLayout';
import DataContainer from '../../../Shared/DataContainer';
import UserCard from '../../Components/UserCard';
import Icon from '../../../Shared/Icon';

const Index = () => {
     const { auth, errors, data } = usePage().props;
     console.log(data);
     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Students</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Students</span>
               </div>
               <DataContainer>
                    <div className="col-span-12">
                         <InertiaLink href={route('student.create')} className="bg-gray-300 hover:bg-gray-400 mr-2 text-gray-800 text-sm py-1 px-1 rounded inline-flex items-center">
                              <Icon name={'plus'} className={'fill-current w-4 h-4 mr-2'} />
                              Add Student
                         </InertiaLink>
                    </div>
               </DataContainer>
               {data.length== 0 && (<div className="col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center">No Student Registered Yet.</div>)}
               {data.length > 0 && (
                    data.map(({id, first_name, last_name, username, name, sex, avatar, content}) => {
                         return <UserCard key={id} user={{'id':id, 'first_name': first_name, 'last_name': last_name, 'name': name, 'username': username, 'sex': sex, 'avatar': avatar, 'content': content}}>
                              <div className="flex justify-center mt-2">
                                   <InertiaLink href={route('student.edit', id)} className="bg-blue-300 hover:bg-blue-400 mr-2 text-blue-800 text-sm py-1 px-1 rounded inline-flex items-center">
                                        <Icon name={'edit'} className={'fill-current w-4 h-4 mr-2'} />
                                        Edit
                                   </InertiaLink>

                                   <InertiaLink href={route('student.show', id)} className="bg-emerald-300 hover:bg-emerald-400 mr-2 text-emerald-800 text-sm py-1 px-1 rounded inline-flex items-center">
                                        <Icon name={'eye'} className={'fill-current w-4 h-4 mr-2'} />
                                        View
                                   </InertiaLink>

                                   <InertiaLink href={route('student.get.content', id)} className="bg-gray-300 hover:bg-gray-400 mr-2 text-gray-800 text-sm py-1 px-1 rounded inline-flex items-center">
                                        <Icon name={'plus'} className={'fill-current w-4 h-4 mr-2'} />
                                        Add Content
                                   </InertiaLink>
                              </div>
                         </UserCard>
                    })
               )}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Index.layout = page => <UserLayout children={page} header={'Students'} />;

export default Index;
